import React, { useEffect, useState } from 'react';
import './Cursor.css';

const Cursor = () => {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [dotPos, setDotPos] = useState({ x: 0, y: 0 });
  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    let dotX = 0, dotY = 0;
    let curX = 0, curY = 0;

    const moveCursor = (e) => {
      curX = e.clientX;
      curY = e.clientY;
      setDotPos({ x: curX, y: curY });
    };

    const animateDot = () => {
      dotX += (curX - dotX) * 0.12;
      dotY += (curY - dotY) * 0.12;
      setPos({ x: dotX, y: dotY });
      requestAnimationFrame(animateDot);
    };

    const handleClick = () => {
      setClicked(true);
      setTimeout(() => setClicked(false), 400);
    };

    const handleHover = () => setHovered(true);
    const handleUnhover = () => setHovered(false);

    window.addEventListener('mousemove', moveCursor);
    window.addEventListener('click', handleClick);

    const links = document.querySelectorAll('a, button, .skill-card, .project-row, .tool-showcase-card');
    links.forEach(el => {
      el.addEventListener('mouseenter', handleHover);
      el.addEventListener('mouseleave', handleUnhover);
    });

    animateDot();

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      window.removeEventListener('click', handleClick);
      links.forEach(el => {
        el.removeEventListener('mouseenter', handleHover);
        el.removeEventListener('mouseleave', handleUnhover);
      });
    };
  }, []);

  return (
    <>
      {/* OUTER RING - follows with delay */}
      <div
        className={`cursor-ring ${hovered ? 'hovered' : ''} ${clicked ? 'clicked' : ''}`}
        style={{ left: `${pos.x}px`, top: `${pos.y}px` }}
      />
      {/* INNER DOT - follows exactly */}
      <div
        className={`cursor-dot ${hovered ? 'hovered' : ''} ${clicked ? 'clicked' : ''}`}
        style={{ left: `${dotPos.x}px`, top: `${dotPos.y}px` }}
      />
    </>
  );
};

export default Cursor;